
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductsGrid extends Serenity.EntityGrid<OrderProductsRow, any> {
        protected getColumnsKey() { return OrderProductsColumns.columnsKey; }
        protected getDialogType() { return OrderProductsDialog; }
        protected getIdProperty() { return OrderProductsRow.idProperty; }
        protected getInsertPermission() { return OrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }
        protected getService() { return OrderProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}